var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65137 7.5C7.65137 11.635 11.0164 15 15.1514 15C19.2864 15 22.6514 11.635 22.6514 7.5C22.6514 3.365 19.2864 0 15.1514 0C11.0164 0 7.65137 3.365 7.65137 7.5ZM28.4847 31.6667H30.1514V30C30.1514 23.5683 24.9164 18.3333 18.4847 18.3333H11.818C5.3847 18.3333 0.151367 23.5683 0.151367 30V31.6667H28.4847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.60a11af00ca4d7d044b4ba0eaceee41d.svg";
export { ForwardRef as ReactComponent };